import { Component, useEffect } from "react";
import styles from "../index.module.less"
import { getBooklistByType, getHomeRank } from "../api";
import { IRankList, IRenderStatus, RankList } from "../typing";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Lazy, Autoplay, SwiperOptions } from 'swiper/core';
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import { YBackGroundImage } from "@/utils/style-methods";
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../config/track-config'
import { isDuApp } from "@/utils/appUtils/getDevice";
import appInstall from "@/utils/appUtils/appInstall";
import Jockeys from "@/utils/jockey";
import { rankTitleMap } from "../config/lang";

SwiperCore.use([Autoplay, Lazy, Pagination])

interface IRankProp {
    language: string;
    countryCode: string;
    rankList: IRankList[]
}

interface IRankState {
    rankInfo: RankList[],
    renderStatus?: IRenderStatus,
}

@withReactTrack({ createTrackConfig })
export default class Rank extends Component<IRankProp, IRankState>{
    constructor(props) {
        super(props);
        this.state = {
            rankInfo: [],
            renderStatus: IRenderStatus.start,
        };
    }

    trackCache = []

    async componentDidMount() {
        try {
            const {countryCode, language} = this.props
            const rankInfo = await getHomeRank({ countryCode, language, region: countryCode });
            if (rankInfo.length > 0) {
                const fRankData = await this.getSingleRankList(rankInfo[0].topId);

                rankInfo[0].spuList = fRankData;
                rankInfo[1].spuList = [];
                rankInfo[2].spuList = [];
            }

            this.setState({
                rankInfo,
                renderStatus: IRenderStatus.ready,
             }, () => {
                this.exposure(rankInfo[0]?.topId, 1, rankInfo[0]?.spuList);
            });
        } catch(e) {
            this.setState({
                renderStatus: IRenderStatus.fail,
            });
        }
    }

    async getSingleRankList(topId: number) {
        const {language, countryCode} = this.props;
        const params = {
            countryCode,
            timeRang: '24h',
            pageSize: 10,
            page: 1,
            language,
            topId
        };
        const data = await getBooklistByType(params);
        // 错误处理在接口 api 文件里面

        if (data) return data.splice(0, 5);
        return []
    }
    // 这个接口只能
    // todo: 根据spuId确定更不更新数据
    async refresh(index) {
        const { rankInfo } = this.state;
        const obj: RankList = rankInfo[index];
        
        if (!obj) return

        obj.spuList = await this.getSingleRankList(obj.topId);
        rankInfo.splice(index, 1, obj);
        
        this.setState({ rankInfo });
    }
    // 曝光埋点，仅第一次触发
    exposure(topId, index, spuList) {
        if (this.trackCache.indexOf(index) === -1) {
            this.trackCache.push(index);
            (this as any).$track('poizon_trade_rank_list_product_exposure', {
                topId,
                index: index + 1,
                spuList: JSON.stringify(spuList)
            });
        }
    }

    goToDetail(ev: any, spuId: number, topId: number, rankIndex: number, position: number) {
        const {language, countryCode} = this.props;
        (this as any).$track('poizon_trade_rank_list_product_click', { spuId, topId, position });
        let url = `https://fast.poizon.com/poizon/detail/${language}/${countryCode}/610950eda158056dd84ddc87`
        if (this.props.rankList && this.props.rankList[rankIndex]) {
            url = this.props.rankList[rankIndex].url
        }

        if (isDuApp()) {
            Jockeys.openNativePage('/web/browser', { url: encodeURIComponent(url) });
        } else {
            appInstall('/web/browser', { url: encodeURIComponent(url) });
        }
        ev.stopPropagation()
    }
    // 默认用户没有填写参数时候直接跳转，但是填写了就使用填写后的，为了PC搭建器服务
    goToRank(index: number) {
        const {language, countryCode} = this.props;
        let url = `https://fast.poizon.com/poizon/detail/${language}/${countryCode}/610950eda158056dd84ddc87`
        if (this.props.rankList && this.props.rankList[index]) {
            url = this.props.rankList[index].url
        }

        if (isDuApp()) {
            Jockeys.openNativePage('/web/browser', { url: encodeURIComponent(url) });
        } else {
            appInstall('/web/browser', { url: encodeURIComponent(url) });
        }
    }

    // 渲染slide集合
    renderSlideMap(rankInfo) {
        const { language } = this.props
        return rankInfo.map((rankData, rankIndex) => {
            const Info = rankData.spuList.map((spu, index) => {
                const back = YBackGroundImage(spu.spuLogoUrl, [{
                    mode: 'resize',
                    width: 28 * 3
                }])
                return (
                    <div className={styles['rank-item']}
                        onClick={(ev)=>this.goToDetail(ev, spu.spuId, rankData.topId, rankIndex, index)}
                        key={spu.spuId}>
                        <div className={styles['rank-item-num']} style={{ color: index < 3 ? '#01C0C1': '#AAAABB'}}>{index + 1}</div>
                        <div className={styles['rank-item-img']} style={{...back}}></div>
                        <div className={styles['rank-item-txt']}>
                            <div className={styles['rank-item-txt-scale']}>
                                {spu.spuName}
                            </div>
                        </div>
                    </div>
                )
            })
            return (
                <SwiperSlide key={rankData.topName}>
                    <div className={styles['rank-warpper']}>
                        <div className={styles['rank-title']} onClick={() => this.goToRank(rankIndex)}>{ rankTitleMap[language]} {rankData.topName}</div>
                        {Info}
                    </div>
                </SwiperSlide>
            )
        })
    }

    swiperParamsInit() {
        const len = this.state.rankInfo.length
        return {
            lazy: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: `.${styles['swiper-pagination']}`,
                clickable: true,
                bulletClass: `${styles['swiper-pagination-bullet']}`,
                bulletActiveClass: `${styles['swiper-pagination-bullet-active']}`,
            },
            // 需要延迟处理
            onInit: (swiper) => {
                setTimeout(async () => {
                    await this.refresh((swiper.activeIndex + 1) % len); 
                }, 1000);
            },
            onSlideChange: async (swiper) => {
                const index = swiper.activeIndex;
                await this.refresh((index + 1) % len);
                const {topId, spuList} = this.state.rankInfo[index];
                this.exposure(topId, index + 1, spuList);
            }
        }
    }

    render() {
        const { rankInfo, renderStatus } = this.state;
        const rank = this.renderSlideMap(rankInfo);
        const swiperParams = this.swiperParamsInit();

        if (rankInfo.length === 0) return (<div></div>);
        if (renderStatus === IRenderStatus.fail) return (<div>榜单接口错误</div>);

        return (
            <>
                <Swiper {...swiperParams}>
                    {rank}
                </Swiper>
                <div className={styles['swiper-pagination']}></div>
            </>
        )
    }
}